import CryptoJS from "crypto-js";

// AES-128-CBC Key and IV (both must be 16 bytes)
const encryptionIV = "teSt@Encryption@"; // 16 bytes IV
const encryptionKey = "dev_dummy_secret_9F3kL#2sP@q8XzA";

// Convert key and IV to WordArray format
const key = CryptoJS.enc.Utf8.parse(encryptionKey);
const iv = CryptoJS.enc.Utf8.parse(encryptionIV);

// Encrypt entire object (Key + Value)
export const hybridEncrypt = (data) => {
    if (!data) return "";

    // Convert object to JSON string before encrypting
    const jsonString = JSON.stringify(data);

    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();  // Return encrypted Base64 string
};

// Decrypt entire object (Key + Value)
export const hybridDecrypt = (encryptedText) => {
    if (!encryptedText) return "";

    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // Convert decrypted text to UTF-8 and parse JSON
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};
